<template>
    <div>
        <transition>
            <div class="echartsContent" v-if="maxEchartShow">
                <echarts :width="900" :height="520"/>
            </div>
        </transition>
        <transition name="mask">
            <div v-if="maxEchartShow" class="maxEcharts" @click="openModal"></div>
        </transition>
    </div>
</template>

<script>
import echarts from './echarts'
export default {
    components: { echarts },
    data() {
        return {
            maxEchartShow: false,
        }
    },
    methods: {
        openModal() {
            this.maxEchartShow = !this.maxEchartShow;
        },
    }

}
</script>

<style lang="scss" scoped>
.v-enter,
.v-leave-to {
    opacity: 0;
    transform: scale(0.6);
}

.v-enter-active,
.v-leave-active {
    transition: all 0.3s linear;
}
.v-leave-active {
    transform: scale(0.2);
}
.maxEcharts {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 300;
}
.echartsContent {
    width: 950px;
    height: 550px;
    padding: 20px;
    background: #fff;
    border-radius: 3px;
    position: fixed;
    z-index: 301;
    left: 50%;
    top: 50%;
    margin: -275px 0 0 -475px;
}
</style>